<template>
  <div class="header">
    <div class="header-block">
      <div class="header-block-left">
        <div class="header-phone-back">
          <img class="form-back" :src="gameBack" alt="form back" />
          <Game v-if="clickCount < 5" v-on:clickCounter="clickCounter" :clickCount="clickCount"/>
          <HeaderForm v-else v-on:clickReset="clickReset" />
        </div>
      </div>
      <div class="header-block-right">
        <div id="trigger"></div>
        <div class="header-small-hd">
          <span>{{ $t('header.headerSmallHd') }}</span>
        </div>
        <div class="header-big-hd">{{ $t('header.headerBigHd') }}</div>
        <div class="header-tx">{{ $t('header.headerTx') }}</div>
        <button
          class="header-btn"
          v-scroll-to="{
              el: '#footer-form',
              duration: 500,
              easing: 'linear',
              offset: this.handleContactOffSet(),
            }"
        >{{ $t('header.headerBtn') }}</button>
        <div class="header-experience-block">
          <ul class="experience-list">
            <li v-for="item in headerBlock" :key="item.text">
              <span class="experience-number">{{ item.text }}</span>
              <span class="experience-text">{{ $t(item.description) }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "./NavBar.vue";
import Game from "./Game.vue";
import HeaderForm from "./HeaderForm.vue";
import { headerBlock, gameBack } from "../configs/header";

export default {
  name: "myHeader",
  props: {
    width: { type: Number, default: null },
  },
  data: () => ({
    headerBlock,
    gameBack,
    clickCount: 0,
    offset: null,
  }),
  components: {
    Game,
    HeaderForm,
  },
  methods: {
    clickCounter() {
      this.clickCount++;
    },
    clickReset() {
      this.clickCount = 0;
    },
    handleContactOffSet() {
      switch (this.width) {
        case 768:
          return -60;
        default:
          return 0;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.game-img {
  box-shadow: 0px 15px 35px rgba(0, 0, 0, 0.15);
  border-radius: 50px;

  @media screen and (max-width: 1130px) {
    width: 274.13px;
    height: 536.7px;
  }
  @media screen and (max-width: 1012px) {
    width: 228.44px;
    height: 447.25px;
  }
}
.header {
  background-image: url("../assets/img/header-back.svg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 1000px;
  background-color: #fffaf0;

  @media screen and (max-width: 1130px) {
    min-height: 814px;
    background-image: url("../assets/img/header-back-1020.svg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  @media screen and (max-width: 1012px) {
    background-image: url("../assets/img/header-back-768.svg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    min-height: 708px;
  }

  @media screen and (max-width: 767px) {
    background-image: url("../assets/img/header-back-480.svg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    min-height: 531px;
  }

  @media screen and (max-width: 479px) {
    background-image: url("../assets/img/header-back-375.svg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    min-height: 495px;
  }
}

.form-back {
  position: relative;
  left: -70px;
  top: -70px;

  @media screen and (max-width: 1130px) {
    width: 410px;
    height: 676px;
  }

  @media screen and (max-width: 1012px) {
    height: 536px;
    width: 368px;
  }
}

#trigger {
  top: 400px;
  position: relative;
  @media screen and (max-width: 480px) {
    top: 250px;
  }

}

.header-phone-back {
  width: 336px;
  height: 654px;
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;

  @media screen and (max-width: 1130px) {
    width: 274px;
    height: 536px;
  }
}

.header-plug {
  width: 322px;
  height: 654px;
  border-radius: 45px;
  position: relative;
  left: 3px;
}

.header-block {
  width: 1040px;
  margin: 0 auto;
  display: flex;
  position: absolute;
  left: 50%;
  top: 186px;
  transform: translateX(-50%);

  @media screen and (max-width: 1130px) {
    width: 100%;
    justify-content: center;
    max-width: 875px;
  }
  @media screen and (max-width: 1012px) {
    max-width: 657px;
        top: 115px;
  }

  @media screen and (max-width: 767px) {
    top: 119px;
  }
}

.header-block-left {
  margin-right: 116px;
  @media screen and (max-width: 1130px) {
    margin-right: 82px;
  }

  @media screen and (max-width: 1012px) {
    margin-right: 0px;
    position: relative;
    top: 54px;
  }

  @media screen and (max-width: 767px) {
    display: none;
  }
}

.header-block-right {
  @media screen and (max-width: 1012px) {
    position: relative;
    left: -8px;
  }
  @media screen and (max-width: 767px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 62px;
    left: 0;
  }

  @media screen and (max-width: 479px) {
    margin: 0 20px;
  }

  @media screen and (max-width: 375px) {
  }
}

.header-small-hd {
  margin-top: 33px;
  margin-bottom: 26px;
  width: 409px;
  height: 96px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 48px;
  line-height: 48px;
  color: #000000;
  @media screen and (max-width: 1012px) {
    font-size: 36px;
    line-height: 100%;
    width: 307px;
    height: 72px;
  }

  @media screen and (max-width: 767px) {
    text-align: center;
    font-size: 30px;
    width: 256px;
    height: 60px;
    margin-top: 0;
    margin-bottom: 10px;
  }

  @media screen and (max-width: 479px) {
    font-size: 26px;
    width: 47%;
    min-width: 226px;
    height: initial;
  }

  @media screen and (max-width: 374px) {
    min-width: 190px;
    font-size: 22px;
  }
}

.header-big-hd {
  width: 103%;
  text-align: left;
  margin-bottom: 50px;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 92px;
  line-height: 100%;
  text-align: center;
  text-transform: uppercase;
  color: #1b516e;
  text-align: left;

  @media screen and (max-width: 1130px) {
    font-size: 80px;
    margin-bottom: 35px;
  }

  @media screen and (max-width: 1012px) {
    font-size: 60px;
    width: 386px;
    line-height: 100%;
    margin-bottom: 33px;
  }

  @media screen and (max-width: 767px) {
    margin-bottom: 30px;
  }

  @media screen and (max-width: 479px) {
    font-size: 52px;
    width: 100%;
    text-align: center;
  }

  @media screen and (max-width: 374px) {
    margin-bottom: 36px;
    font-size: 43px;
  }
}

.header-tx {
  margin-bottom: 32px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 100%;
  color: #000000;

  @media screen and (max-width: 1130px) {
    font-size: 18px;
    line-height: 100%;
    margin-bottom: 23px;
  }

  @media screen and (max-width: 1012px) {
    font-size: 16px;
    margin-bottom: 15px;
  }

  @media screen and (max-width: 767px) {
    margin-bottom: 10px;
  }

  @media screen and (max-width: 479px) {
    margin-bottom: 16px;
    font-size: 14px;
  }
}

.header-btn {
  width: 240px;
  height: 60px;
  left: 889px;
  top: 535px;
  background: #1899e1;
  border-radius: 40px;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  text-transform: uppercase;

  color: #ffffff;

  @media screen and (min-width: 769px) {
    &:hover {
      background: #26b1ff;
      box-shadow: 0px 0px 15px #26b1ff;
    }

    &:active {
      background: #1187ca;
      box-shadow: none !important;
    }
  }
}

.experience-list {
  display: flex;
  margin-top: 157px;

  li {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    &:first-child {
      margin-right: 14px;
    }

    &:nth-child(2) {
      margin-right: 24px;
    }
  }

  @media screen and (max-width: 1130px) {
    margin-top: 84px;
  }

  @media screen and (max-width: 1012px) {
    margin-top: 60px;
  }

  @media screen and (max-width: 767px) {
    margin-top: 40px;
  }

  @media screen and (max-width: 479px) {
    margin-top: 36px;
  }
}

.experience-number {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
  line-height: 53px;
  text-align: center;
  color: #1b516e;
  opacity: 0.5;

  @media screen and (max-width: 1130px) {
    line-height: 42px;
    margin-bottom: 12px;
  }

  @media screen and (max-width: 1012px) {
    font-size: 30px;
    line-height: 35px;
    margin-bottom: 10px;
  }

  @media screen and (max-width: 479px) {
    font-size: 24px;
    margin-bottom: 5px;
  }
}

.experience-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;
  color: #000000;
  opacity: 0.5;

  @media screen and (max-width: 1130px) {
    font-size: 14px;
    line-height: 16px;
  }

  @media screen and (max-width: 479px) {
    font-size: 12px;
  }
}
</style>
